var _line, _rect, _rect2, _rect3, _line2, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrailerBoxOutlineDepan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 300,
    x2: 580,
    y2: 300,
    stroke: "#c7ccd1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 90,
    width: 340,
    height: 190,
    rx: 6,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 98,
    width: 162,
    height: 174,
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 98,
    width: 162,
    height: 174,
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 90,
    x2: 320,
    y2: 280,
    stroke: "#1d4256",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 176,
    width: 18,
    height: 10,
    rx: 3,
    fill: "#1d4256"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 176,
    width: 18,
    height: 10,
    rx: 3,
    fill: "#1d4256"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 272,
    width: 340,
    height: 16,
    fill: "#1d4256"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 300,
    r: 28,
    fill: "#2a2e33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 300,
    r: 12,
    fill: "#8b9096"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 300,
    r: 28,
    fill: "#2a2e33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 300,
    r: 12,
    fill: "#8b9096"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerBoxOutlineDepan);
export default __webpack_public_path__ + "static/media/trailer-box-outline-depan.7bd0ab6e7a8ca6759328f5ae7555c024.svg";
export { ForwardRef as ReactComponent };